module.exports = __webpack_public_path__ + "img/ring_y_l_null_0.e5099808.png";